import React from 'react';
import Spark from '~/images/careers/spark-rotate.svg';

function JobListing({ jobTitle, jobLocation, jobApply, jobApplyText }) {
  return (
    <div className="flex items-center justify-between px-8 xs:flex-col sm:flex-row bg-light-grey py-7 ">
      <div className="flex items-center">
        <div className="transform -rotate-45">
          <img src={Spark} />
        </div>
        <div className={`ml-7`}>
          <h4 className="text-20px">{jobTitle}</h4>
          <h4 className="font-bold text-20px">{jobLocation}</h4>
        </div>
      </div>
      <div>
        <h4 className="border-b-0 border-black md:border-b text-20px">
          {jobApply && (
            <a href={jobApply} className="transition-opacity duration-200 hover:opacity-50">
              {jobApplyText}
            </a>
          )}
        </h4>
      </div>
    </div>
  );
}

export default JobListing;
